import React from "react";
import { LongYellowLine } from "../../svg/LongYellowLine";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { First } from "./First";
import { Second } from "./Second";
import { Third } from "./Third";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import { BackArrow } from "../../svg/BackArrow";
import { prevPage } from "../../stores/credit/credit.reducer";
import { useCreditSelector } from "../../stores/product/product.store";

export const Credit = () => {
    const page = useCreditSelector((state: CreditState) => state.page);
    const text = useCreditSelector((state: CreditState) => state.text);
    const isShowConfirmedPhone = useCreditSelector((state: CreditState) => state.isShowConfirmedPhone);
    const dispatch = useCreditDispatch();

    const back = () => {
        dispatch(prevPage());
    }

    return (

        <div className="bg-light-gray rounded-2xl w-full md:p-8 p-4">
            <div className="mb-6">
                <p className="uppercase text-3xl md:text-4xl mb-4 smart-font">{ text.credit } <span
                    className="text-gray">{ page }/3</span></p>
                <LongYellowLine/>
            </div>
            { page > 1 && !isShowConfirmedPhone && <BackArrow onClick={ () => back() } /> }
            { page === 1 && <First/> }
            { page === 2 && <Second/> }
            { page === 3 && <Third/> }
        </div>
    );
}